export const getLoginStrategy = (strategy: string) => {
  const parsedStrategy = strategy.replace("from_oauth_", "");
  switch (parsedStrategy) {
    case "facebook":
      return "facebook";
    case "google":
      return "google";
    case "apple":
      return "apple";
    default:
      return "email";
  }
};
